// extracted by mini-css-extract-plugin
export default {"container":"ss-z","heading":"ts-z","text":"us-z","info":"vs-z","link":"ws-z","fullMaxWidth":"xs-z"};